import { AlertTypography } from '@/components/UI/Typography';
import { CircularProgress } from '@mui/material';

import { Constants } from '../../constants';
import {
  ButtonBox,
  DialogContainer,
  FilledButton,
  OutlinedButton,
  StyledDialog,
  TextTypography,
} from './styles';

interface ApproveConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
}

export function ApproveConfirmationDialog({
  open,
  onClose,
  onConfirm,
  loading,
}: ApproveConfirmationDialogProps): JSX.Element {
  const handleConfirm = (): void => {
    onConfirm();
    onClose();
  };

  return (
    <StyledDialog
      open={open}
      onClose={onClose}
      aria-labelledby="approve-os-dialog"
    >
      <DialogContainer>
        <TextTypography>{Constants.approveConfirmText}</TextTypography>
        <ButtonBox>
          <OutlinedButton onClick={onClose} disabled={loading}>
            {Constants.cancel}
          </OutlinedButton>
          <FilledButton onClick={handleConfirm} disabled={loading}>
            {loading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              Constants.confirm
            )}
          </FilledButton>
        </ButtonBox>
        <AlertTypography>{Constants.undoText}</AlertTypography>
      </DialogContainer>
    </StyledDialog>
  );
}
